import { Layers, Store, MessagesSquare, MapPin } from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";

const POINTS = [
    {
        icon: Layers,
        title: "Diverse Product Categories",
        description: "Access to a range of everyday consumer and retail products.",
    },
    {
        icon: Store,
        title: "Wholesale & Retail Experience",
        description: "Serving both business and general retail requirements.",
    },
    {
        icon: MessagesSquare,
        title: "Customer-Focused Approach",
        description: "We aim to make communication and product enquiries straightforward.",
    },
    {
        icon: MapPin,
        title: "UK-Based Business",
        description: "Operating from Croydon, United Kingdom.",
    },
];

export const WhyPisi = () => (
    <section data-testid="why-work-with-us-section" className="bg-navy-950">
        <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
            <SectionHeading dark eyebrow="Why Choose Us" title="Why Work With PISI LIMITED?" />
            <div className="mt-14 grid gap-px bg-white/10 sm:grid-cols-2">
                {POINTS.map((point, i) => (
                    <Reveal key={point.title} delay={(i % 2) * 120} className="h-full">
                        <div
                            data-testid={`why-point-${i + 1}`}
                            className="group h-full bg-navy-950 p-8 transition-colors duration-300 hover:bg-navy-900 lg:p-10"
                        >
                            <point.icon className="h-6 w-6 text-gold" />
                            <h3 className="mt-5 font-heading text-lg font-semibold text-white">
                                {point.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-slate-400">
                                {point.description}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
